import { defineStore } from "pinia";
import { MeAPI } from "@/util/generated/api-backoffice-public";

export const useAuthStore = defineStore("auth", () => {
  const auth = ref(null);
  const me = ref(null);

  const isAuthenticated = computed(() => !!auth.value);

  async function authenticate(payload = undefined) {
    // Load auth if not passed in parameters
    if (payload && payload.access_token) {
      auth.value = payload;
    } else if (!auth.value && localStorage?.getItem("bearer-token")) {
      auth.value = {
        access_token: localStorage?.getItem("bearer-token"),
        expires_in: null,
        expires_date: null,
      };
    }

    // Calculate expires_date if not set
    if (auth.value && !auth.value.expires_date) {
      auth.value.expires_date = new Date().getTime() + (auth.value.expires_in || 14400) * 1000;
    }

    // Check validity of auth token
    if (auth.value && auth.value.expires_date < new Date().getTime() + 60000) {
      logout();
      return null;
    }

    // Don't load me from server if already loaded and auth still valid
    if (auth.value === payload && me.value) {
      return me.value;
    }

    // Save auth and set headers
    if (payload && payload.access_token) {
      localStorage.setItem("bearer-token", payload.access_token);
    }

    // Load me from server
    try {
      me.value = await MeAPI.getCurrentUser();
      if (!me.value && auth.value) {
        auth.value = null;
        localStorage.removeItem("bearer-token");
      }
    } catch (err) {
      console.error("Unexpected error during authentication", err);
      logout();
    }

    return me.value;
  }

  async function logout() {
    auth.value = null;
    me.value = null;
    localStorage.removeItem("bearer-token");
  }

  function setMe(userData) {
    me.value = userData;
  }

  return {
    auth,
    me,
    isAuthenticated,
    setMe,
    authenticate,
    logout,
  };
});
